<div *ngIf="((!(hasViewMoneyAccess$ | async) && (authorizedFinished$ | async)) || (authorizedFailed$ | async))" id="standing-authorizations-content">
    <mm-view-move-money-page></mm-view-move-money-page>
</div>
<div *ngIf="(hasViewMoneyAccess$ | async)" id="standing-authorizations-content">
  <div *ngIf="accountInContext || masterAccountInContext else legacyRedirect;">
    <ng-container *ngIf="showMasterStatusView; then masterViewContent; else accountViewContent;"></ng-container>
    <ng-template #masterViewContent>
      <mm-sa-master-status-view id="sa-msv-component"></mm-sa-master-status-view>
      <mm-view-page id="sa-master-view-page" *ngIf="(createSloaStep$ | async) === 'view-msv'"></mm-view-page>
    </ng-template>
    <ng-template #accountViewContent>
      <div>
      <mm-account-info></mm-account-info>
      <mm-cancel-modal-v2></mm-cancel-modal-v2>
      <div *ngIf="(createSloaStep$ | async) === 'input'">
          <mm-standing-authorizations-input-page></mm-standing-authorizations-input-page>
      </div>
      <div *ngIf="(createSloaStep$ | async) === 'view'">
          <mm-view-page></mm-view-page>
      </div>
      <div *ngIf="(createSloaStep$ | async) === 'review'">
          <mm-standing-authorization-review-page></mm-standing-authorization-review-page>
      </div>
      <div *ngIf="(createSloaStep$ | async) === 'confirmation'">
          <mm-standing-authorization-confirmation-page></mm-standing-authorization-confirmation-page>
      </div>
      </div>
    </ng-template>
  </div>
</div>
<ng-template #legacyRedirect>
    <mm-legacy-redirect-landing-page></mm-legacy-redirect-landing-page>
</ng-template>
